import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/relationship-health/')({
  beforeLoad: () => {
    throw redirect({ replace: true, to: '/relationship-health/login' });
  }
});
